import React from 'react';
import ReactDOM from 'react-dom';
import App from './Components/App';
import { FirebaseContextProvider } from './Components/Firebase';
import * as serviceWorker from './serviceWorker';
import './index.css';
import { createStore, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import { userReducer, projectReducer, bidReducer } from './Redux';

const rootReducer = combineReducers({
  Auth: userReducer,
  Project: projectReducer,
  Bid: bidReducer,
});

const store = createStore(rootReducer);

ReactDOM.render(
  <Provider store={store}>
    <FirebaseContextProvider>
      <App />
    </FirebaseContextProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
